import React from 'react';
import MomentUtils from '@date-io/moment';
import { useField, useFormikContext } from 'formik';

import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import Box from '@material-ui/core/Box';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import './time.scss';

import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import moment from 'moment';

const useLabelStyles = makeStyles({
  root: {
    marginBottom: 10,
  },
});

const useInputStyles = makeStyles({
  root: {
    background: 'rgba(0, 0, 0, 0.04)',
  },
  input: {
    fontWeight: '400',
    paddingLeft: 5,
    paddingRight: 5,
  },
});

const MaterialTime = ({
  name,
  required,
  label,
  additionalStyles = {},
  storageFormat = 'HH:mm:00',
  displayFormat = 'h:mm A',
  disabled = false,
}) => {
  const [field, meta, helpers] = useField(name);
  const { error } = meta;
  const { submitCount } = useFormikContext();
  const labelStyles = useLabelStyles();
  const inputStyles = useInputStyles();

  const hasError = submitCount && error ? true : false;

  const handleChange = value => {
    if (value) {
      helpers.setValue(value.format(storageFormat));
    } else {
      helpers.setValue(null);
    }
  };

  const parseValue = value => {
    if (value) {
      return moment(value, storageFormat);
    } else {
      return null;
    }
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <div className={additionalStyles?.container || 'time-picker'}>
        <InputLabel
          variant="standard"
          disableAnimation
          shrink={false}
          classes={labelStyles}
          error={hasError}
          required={required}
          htmlFor={field.name}
          className={additionalStyles.label}
          disabled={disabled}
        >
          {label}
        </InputLabel>
        <KeyboardTimePicker
          value={parseValue(field.value)}
          onBlur={field.onBlur}
          name={field.name}
          variant="inline"
          format={displayFormat}
          required={required}
          emptyLabel
          onChange={handleChange}
          fullWidth
          InputProps={{
            classes: inputStyles,
            readOnly: true,
            value: field.value ? moment(field.value, storageFormat).format(displayFormat) : '',
            disabled: disabled,
          }}
          className={additionalStyles.input}
          keyboardIcon={disabled ? null : <AccessTimeIcon color="primary" />}
          disabled={disabled}
        />
        {hasError ? (
          <Box component="span" color="error.main" fontWeight="400">
            {error}
          </Box>
        ) : null}
      </div>
    </MuiPickersUtilsProvider>
  );
};

export default MaterialTime;
